import { USER_DATA_QUERY_KEY } from '@/shared/constants/queryKeys';

export const USER_QUERY_KEYS = {
  account: ['account'],
  cognitoUser: ['cognitoUser'],
  paidTrialAccess: (userId = '') => ['paidTrialAccess', userId],
  userApiKey: ['userApiKey'],
  userData: USER_DATA_QUERY_KEY,
  userSettings: (isAuthenticated = false, spaceId = '') => ['userSettings', isAuthenticated, spaceId],
} as const;
